import { Button, Container } from '@mui/material';
import { useSnackbar } from 'notistack';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';

import CustomBreadcrumbs from '@/commons/custom-breadcrumbs/CustomBreadcrumbs';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { PATH_DASHBOARD } from '@/routes/paths';
import { addOrderDetailService } from '@/services';
import { translates } from '@/utils';
import { TITLE } from '@/utils/constants';
import OrderDetailNewForm from '../form/order-detail';
import { useFetch } from '../hooks/useFetch';

export default function AddOrderProductPage() {
  const { enqueueSnackbar } = useSnackbar();
  const [isGrid, setIsGrid] = useLocalStorage({ key: `${TITLE}/use-grid`, defaultValue: false });
  const navigate = useNavigate();

  const { id } = useParams();
  const { isLoading, fetchProperties: onSubmit } = useFetch({
    fetchFunction: addOrderDetailService,
  });

  const onSave = async (values: any) => {
    if (id) {
      try {
        await onSubmit(id, values);
        enqueueSnackbar('Create success OrderDetail!');
        navigate(PATH_DASHBOARD.orders.view(id));
      } catch (error) {
        if (error?.error === 'not-have-ingredients-to-all-products') {
          enqueueSnackbar(`\n Producto :${error?.data?.name} \n Cantidad Posible : ${error.max}`, {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Problemas Añadiendo Productos', { variant: 'error' });
        }
      }
    }
  };

  return (
    <div>
      <Helmet>
        <title> {import.meta.env.VITE_TITLE_BUSINESS}: Add Order Product</title>
      </Helmet>
      <Container maxWidth={false}>
        <CustomBreadcrumbs
          heading={translates.addOrderProduct}
          links={[
            { name: translates.dashboard, href: PATH_DASHBOARD.root },
            {
              name: translates.order,
              href: PATH_DASHBOARD.orders.root,
            },
            {
              name: translates.detail,
              href: PATH_DASHBOARD.orders.view(id ?? ''),
            },
            { name: id?.slice(0, 7) ?? '' },
          ]}
          action={[
            <Button
              variant="outlined"
              sx={{ width: { sm: 'auto', xs: '90vw' } }}
              color="info"
              onClick={() => setIsGrid((prev) => !prev)}
            >
              {!isGrid ? [translates.gridMood] : [translates.listMood]}
            </Button>,
          ]}
        />
        <OrderDetailNewForm isGrid={isGrid} isLoading={isLoading} onSave={onSave} />
      </Container>
    </div>
  );
}
